import React from 'react';
import PropTypes from 'prop-types';

const BoxLinkContainer = ({ children }) => (
  <div className="boxlink__container">{children}</div>
);

BoxLinkContainer.propTypes = {
  children: PropTypes.node.isRequired
};

export default BoxLinkContainer;



// WEBPACK FOOTER //
// ./src/components/Common/BoxLink/BoxLinkContainer.js